import React from 'react';
import { motion } from 'framer-motion';
import { useNavigate } from 'react-router-dom';
import { ArrowRight, Check, FileText, BarChart3 } from 'lucide-react';
import './BookCard.css';

const BookCard = ({ book, index }) => {
  const navigate = useNavigate();
  const goToPreview = () => navigate(`/preview/${book.id}`);

  return (
    <motion.article
      className="book-card"
      variants={{
        hidden: { opacity: 0, y: 40 },
        visible: {
          opacity: 1,
          y: 0,
          transition: { duration: 0.6, ease: [0.22, 1, 0.36, 1] },
        },
      }}
      initial="hidden"
      whileInView="visible"
      viewport={{ once: true, margin: '-60px' }}
    >
      <div className="book-cover" onClick={goToPreview} role="button" tabIndex={0}
        onKeyDown={(e) => (e.key === 'Enter' ? goToPreview() : null)}
        aria-label={`Preview ${book.title}`}>
        <span className="book-index">{String(index + 1).padStart(2, '0')}</span>
        <img
          src={book.coverImage}
          alt={`${book.title} — ${book.subtitle}`}
          className="book-cover-image"
          loading="lazy"
        />
        <div className="book-cover-glow" aria-hidden="true" />
      </div>

      <div className="book-body">
        <span className="book-category">{book.category}</span>
        <h3 className="book-title">{book.title}</h3>
        <p className="book-subtitle">{book.subtitle}</p>
        <p className="book-description">{book.description}</p>

        <ul className="book-highlights">
          {book.highlights.slice(0, 3).map((h) => (
            <li key={h}>
              <Check size={15} strokeWidth={2.5} />
              <span>{h}</span>
            </li>
          ))}
        </ul>

        <div className="book-meta">
          <span>
            <FileText size={14} /> {book.pages} pages
          </span>
          <span>
            <BarChart3 size={14} /> {book.difficulty}
          </span>
        </div>

        <button className="book-cta" onClick={goToPreview}>
          <span>Get this book free</span>
          <ArrowRight size={18} />
        </button>
      </div>
    </motion.article>
  );
};

export default BookCard;
